import { render } from "./TestimonialsPage.vue?vue&type=template&id=1870dd26&scoped=true"
const script = {}

import "./TestimonialsPage.vue?vue&type=style&index=0&id=1870dd26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1870dd26"]])

export default __exports__